import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DataGridComponent from "../../../components/DataGridComponent";
import Loader from "../../../components/Loader";
import AlertComponent from "../../../components/alert";
import { showSnackbar } from "../../../slice/snackbarSlice";
import { transferInstructionToConsultant } from "../../../thunks/instruction";
import { getConsultant } from "../../../thunks/user";
import { NOTIFICATION_MESSAGE } from "../../../utils/constant";
import { clientTransfer } from "../../../thunks/client";

const TransferConsultantDialog = ({
  open,
  handleClose,
  instructionId,
  isClient,
}) => {
  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 10,
      sortable: false,
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 220,
      sortable: false,
      renderCell: (params) => {
        return <>{`${params?.row?.firstName} ${params?.row?.lastName}`}</>;
      },
    },
    {
      field: "action",
      headerName: "Transfer Instruction",
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            fullWidth
            variant="outlined"
            className="meeting_log_btn normal_normal_semibold_14_Manrope green"
            style={{
              borderRadius: "24px",
              margin: 1,
              border: "1px solid #00ce3f",
            }}
            onClick={() => handleClickTranserInstruction(params)}
          >
            Transfer
          </Button>
        );
      },
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isTransfer, setIsTransfer] = useState(false);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [isLoader, setLoader] = useState(false);
  const [consultants, setConsultants] = useState([]);
  const [filterConsultants, setFilterConsultants] = useState([]);
  const consultsantData = useSelector(
    isClient
      ? (state) => state?.client?.leadClientData
      : (state) => state?.instruction?.instructionDashboardData
  );

  // Method to fetch all consultants.
  const getAllConsultants = async () => {
    try {
      setLoader(true);
      const response = await dispatch(getConsultant()).unwrap();
      if (response?.length > 0) {
        //filtered current consultant
        const filteredData = response.filter((d) => {
          const isConsultantClient =
            consultsantData?.ownerOfClient?.role === "Consultant" &&
            consultsantData?.ownerOfClient?.email;

          const isConsultantInstruction =
            consultsantData?.ownerOfInstruction?.role === "Consultant" &&
            consultsantData?.ownerOfInstruction?.email;
          return (
            d?.email !==
            (isClient ? isConsultantClient : isConsultantInstruction)
          );
        });

        const sortedData = [...filteredData]?.sort((a, b) => {
          return a?.firstName?.localeCompare(b?.firstName);
        });
        setConsultants(sortedData);
        setFilterConsultants(sortedData);
        setLoader(false);
      } else {
        setConsultants([]);
        setFilterConsultants([]);
        setLoader(false);
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  const handleClickTranserInstruction = (params) => {
    setSelectedConsultant(params?.row?.id);
    setIsTransfer(true);
  };

  const successTransferInstruction = async () => {
    try {
      setLoader(true);
      const payload = isClient
        ? {
            clientId: instructionId,
            transferToId: selectedConsultant,
          }
        : {
            instructionId: instructionId,
            counsultantIdTo: selectedConsultant,
          };
      const response = await dispatch(
        isClient
          ? clientTransfer(payload)
          : transferInstructionToConsultant(payload)
      ).unwrap();
      if (response) {
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message: isClient
              ? NOTIFICATION_MESSAGE?.SUCCESS_CLIENT_TRANSFER
              : response?.message
              ? response?.message
              : NOTIFICATION_MESSAGE?.SUCCESS_TRANSFER_INSTRUCTION,
            severity: "success",
          })
        );
        handleClose();
        navigate(isClient ? "/app/client/list" : "/app/instructions/list");
      }
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message,
          severity: "error",
        })
      );
      handleClose();
    }
  };
  // Method to filter consultantData based on search with firstName and lastName with spacing between them
  const handleChangeSearch = (value) => {
    const searchValue = value.toLowerCase();
    const filteredData = filterConsultants?.filter((data) => {
      const fullName = `${data?.firstName} ${data?.lastName}`.toLowerCase();
      return fullName.includes(searchValue);
    });
    setConsultants(filteredData);
  };

  useEffect(() => {
    getAllConsultants();
  }, []);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{ sx: { borderRadius: "28px", paddingBottom: 0 } }}
      >
        {isTransfer && (
          <AlertComponent
            open={isTransfer}
            handleSuccess={successTransferInstruction}
            handleClose={() => setIsTransfer(false)}
            message={`Are you sure you want to transfer ${
              isClient ? "client" : "case"
            }?`}
          />
        )}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* Loader Component */}
        {isLoader && <Loader />}
        <DialogContent
          dividers={true}
          sx={{ marginRight: "5px" }}
          className="instruction_dashboard_scrollbar"
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 40,
                alignItems: "center",
              }}
            >
              <Typography
                className="serif_display_regular_26 green"
                textAlign={"center"}
              >
                Consultants
              </Typography>
              <TextField
                fullWidth
                className="textField_outlined_border"
                placeholder="search..."
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "30px",
                  },
                }}
                onChange={(e) => handleChangeSearch(e?.target?.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} style={{ width: "100%", height: "75vh" }}>
              <DataGridComponent
                columns={columns}
                rows={consultants}
                onRowClick={() => null}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TransferConsultantDialog;
